export const blockIconsCommunicationForumNew = (
	<span className='material-symbols-outlined'>forum</span>
);
